import React from 'react'

import Header from 'components/Text/Header'
import CrossButton from 'components/Buttons/CrossButton'
import {
	Container,
	TokenRow,
	TokenIcon,
	ResumeIcon,
	Token,
	HorizontalSeparator,
	GotItButton,
} from './WhatAreTokens.styles'

interface WhatAreTokensProps {
	onGotIt: () => any,
	onClose: () => any,
}

export default function WhatAreTokens(
	{
		onClose,
		onGotIt,
		...props
	}: WhatAreTokensProps,
) {

	return (
		<Container {...props}>
			<Header>
				What are tokens?
			</Header>
			<CrossButton
				onClick={onClose}
			/>
			<p className='subtitle'>
				Tokens are used to view the Contact Information of qualified candidates.
			</p>
			<div className='valueProps'>
				<div className='valueProp'>• It's FREE to post your job</div>
				<div className='valueProp'>• It's FREE to review Candidates</div>
				<div className='valueProp'>• It's FREE to Hire! We don't charge any additional fees for permanent hires</div>
			</div>
			<p className='explanation'>
				Once you review a Candidate and decide they might be a good fit, you use a Token to view their Contact Information.
			</p>
			<p className='explanation'>
				From there - you can contact them freely, set up interviews and hire them without any additional fees.
			</p>
			<p className='additionalInfo'>
				You can purchase more Tokens (they are inexpensive), and if you have multiple locations, you can use them across any of your offices.
			</p>
			<TokenRow>
				<div>
					<TokenIcon />
					1 token
				</div>
				<p className='equals'>
					=
				</p>
				<div>
					<ResumeIcon />
					View Candidate Contact Info
				</div>
			</TokenRow>
			<p className='firstTokens'>
				To get you started, your first 2 tokens are free.
			</p>
			<Token
				id={0}
				count={2}
				countryCode={'CA'}
				price={'Free!'}
			/>
			<HorizontalSeparator />
			<GotItButton
				onClick={onGotIt}
			>
				Got it
			</GotItButton>
		</Container>
	)
}
